import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import AccordionIcon from "assets/icons/AccordionIcon";
import { ReactNode, useEffect, useState } from "react";

interface AccordionCardProps {
  title: string | ReactNode;
  children: ReactNode;
  hide?: boolean;
  accordionProps?: Partial<AccordionProps>;
  TextFieldEnd?: ReactNode;
}

const AccordionCard = ({ title, children, hide = false, accordionProps, TextFieldEnd }: AccordionCardProps) => {
  const { sx: accordionSx, ...restAccordionProps } = accordionProps || {};
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (hide) setExpanded(false);
  }, [hide]);

  return (
    <Accordion
      expanded={expanded}
      onChange={toggleExpanded}
      sx={{
        ...(hide && {
          visibility: "hidden",
          opacity: 0,
        }),
        maxHeight: "500px",
        overflow: "auto",
        borderRadius: 2,
        "&:first-of-type": { borderRadius: 2 },
        "&.Mui-expanded": { marginBottom: 0 },
        "& .MuiAccordionSummary-root": { minHeight: "auto !important" },
        "& .MuiAccordionSummary-content": { alignItems: "center", marginY: 0 },
        "& .MuiAccordionSummary-content.Mui-expanded": { marginY: 0 },
        ...accordionSx,
      }}
      {...restAccordionProps}>
      <AccordionSummary>
        <Stack
          direction='row'
          alignItems='center'
          spacing={0.5}>
          {typeof title === "string" ? <Typography fontWeight={500}>{title}</Typography> : title}
          {TextFieldEnd}
        </Stack>
        <AccordionActions sx={{ marginLeft: "auto", padding: 0 }}>
          <IconButton
            sx={{
              width: 36,
              height: 36,
              color: "base.200",
              transition: "transform 300ms ease",
              transform: expanded ? "rotateZ(180deg)" : "none",
            }}>
            <AccordionIcon />
          </IconButton>
        </AccordionActions>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionCard;
